import { axios } from '@/utils/request'
const api = {
  create:'/finance/enterpriseStatement',
}
// 获取列表数据
export function getSubList (parameter) {
  return axios({
    url: api.create + '/subList',
    method: 'get',
    params: parameter
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/finance/enterpriseStatement/subExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
// 获取列表数据
export function getSubStatementDetailList (parameter) {
  return axios({
    url: api.create + '/subStatementDetail',
    method: 'get',
    params: parameter
  })
}
// 客户自费生成对账单
// export function getFinanceSubmit (parameter) {
//   return axios({
//     url: api.create + '/subStatementDetail',
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

export const sourceExport = api.source + '/export'